document.addEventListener('DOMContentLoaded', function() {
    
    
    /**
     * Petición Ajax
     */
    function ajax_get(url, callback) {
        var xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
                //console.log('responseText:' + xmlhttp.responseText);
                try {
                    var data = JSON.parse(xmlhttp.responseText);
                } catch(err) {
                    //console.log(err.message + " in " + xmlhttp.responseText);
                    return;
                }
                callback(data);
            }
        };
    
        xmlhttp.open("GET", url, true);
        xmlhttp.send();
    }


    /*
    * Autocompletado
    */
    function autocomplete(inp, arr) {
        /*the autocomplete function takes two arguments,
        the text field element and an array of possible autocompleted values:*/
        var currentFocus;
        /*execute a function when someone writes in the text field:*/
        inp.addEventListener("input", function(e) {
            var a, b, footer, submenu, i, val = this.value;
            /*close any already open lists of autocompleted values*/
            closeAllLists();
            if (!val) { return false;}
            currentFocus = -1;
            /*create a DIV element that will contain the items (values):*/
            a = document.createElement("DIV");
            a.setAttribute("id", this.id + "autocomplete-list");
            a.setAttribute("class", "autocomplete-items");
            /*append the DIV element as a child of the autocomplete container:*/

          	// Si hay acentos, los quita. Letra a letra
          	var letras_val = val.split('');
            letras_val.forEach( function(valor, indice, array) {
              	letras_val[indice] = quitar_acentos(valor);
            });
          	val = letras_val.join('');

            /*for each item in the array...*/
            for (i = 0; i < arr.length; i++) {
                /*check if the item starts with the same letters as the text field value:*/
                if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
                /*create a DIV element for each matching element:*/
                b = document.createElement("DIV");
                /*make the matching letters bold:*/
                b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
                b.innerHTML += arr[i].substr(val.length);
                /*insert a input field that will hold the current array item's value:*/
                b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                /*execute a function when someone clicks on the item value (DIV element):*/
                    b.addEventListener("click", function(e) {
                    /*insert the value for the autocomplete text field:*/
                    inp.value = this.getElementsByTagName("input")[0].value;
                    if(inp.value == 'Nueva York'){
                        document.getElementById("myInput").value = "Estados Unidos";
                    }
                    if(inp.value == 'New York'){
                        document.getElementById("myInput").value = "Estados Unidos";
                    }
                    if(inp.value == 'Paquistan'){
                        document.getElementById("myInput").value = "Pakistan";
                    }
                    if(inp.value == 'Bali'){
                        document.getElementById("myInput").value = "Indonesia";
                    }
                    if(inp.value == 'USA'){
                        document.getElementById("myInput").value = "Estados Unidos";
                    }
                    if(inp.value == 'California'){
                        document.getElementById("myInput").value = "Estados Unidos";
                    }
                    if(inp.value == 'Miami'){
                        document.getElementById("myInput").value = "Estados Unidos";
                    }
                    if(inp.value == 'EEUU'){
                        document.getElementById("myInput").value = "Estados Unidos";
                    }
                    if(inp.value == 'eeuu'){
                        document.getElementById("myInput").value = "Estados Unidos";
                    }
                    if(inp.value == 'Los Ángeles'){
                        document.getElementById("myInput").value = "Estados Unidos";
                    }

                    dataLayer.push({
                        'category': 'Interaccion', 'action': 'Resultado buscador', 'label': inp.value,
                        'event': 'eventga'
                    });

                    /*close the list of autocompleted values,
                    (or any other open lists of autocompleted values:*/
                    closeAllLists();
                      document.getElementById('buscador-destinos').submit();
                });
                a.appendChild(b);
                }
            }
            submenu = document.getElementById('submenu-buscador').innerHTML;
            this.parentNode.appendChild(a);
            //footer = document.createElement('footer');
            //footer.innerHTML = submenu;
            //a.appendChild(footer);
            
        });
        /*execute a function presses a key on the keyboard:*/
        inp.addEventListener("keydown", function(e) {
            var x = document.getElementById(this.id + "autocomplete-list");
            if (x) x = x.getElementsByTagName("div");
            if (e.keyCode == 40) {
                /*If the arrow DOWN key is pressed,
                increase the currentFocus variable:*/
                currentFocus++;
                /*and and make the current item more visible:*/
                addActive(x);
            } else if (e.keyCode == 38) { //up
                /*If the arrow UP key is pressed,
                decrease the currentFocus variable:*/
                currentFocus--;
                /*and and make the current item more visible:*/
                addActive(x);
            } else if (e.keyCode == 13) {
                /*If the ENTER key is pressed, prevent the form from being submitted,*/
                //e.preventDefault();
                if (currentFocus > -1) {
                /*and simulate a click on the "active" item:*/
                if (x) x[currentFocus].click();
                    console.log(inp.value);
                  document.getElementById('buscador-destinos').submit();
                }
            }
        });
            
        function addActive(x) {
            /*a function to classify an item as "active":*/
            if (!x) return false;
            /*start by removing the "active" class on all items:*/
            removeActive(x);
            if (currentFocus >= x.length) currentFocus = 0;
            if (currentFocus < 0) currentFocus = (x.length - 1);
            /*add class "autocomplete-active":*/
            x[currentFocus].classList.add("autocomplete-active");
        }
            
        function removeActive(x) {
            /*a function to remove the "active" class from all autocomplete items:*/
            for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("autocomplete-active");
            }
        }
            
        function closeAllLists(elmnt) {
            /*close all autocomplete lists in the document,
            except the one passed as an argument:*/
            var x = document.getElementsByClassName("autocomplete-items");
            for (var i = 0; i < x.length; i++) {
                if (elmnt != x[i] && elmnt != inp) {
                    x[i].parentNode.removeChild(x[i]);
                }
            }
        }
      
      	function quitar_acentos (s) {
          if (!s) { return ''; }
          var ret = '';
          var accent_map = { 'á':'a', 'é':'e', 'í':'i','ó':'o','ú':'u', 'Á':'A', 'É':'E', 'Í':'I', 'Ó':'O', 'Ú':'U' };
          for (var i = 0; i < s.length; i++) {
            ret += accent_map[s.charAt(i)] || s.charAt(i);
          }
          return ret;
        };
            
            
        /*execute a function when someone clicks in the document:*/
        document.addEventListener("click", function (e) {
            closeAllLists(e.target);
        });
    }

    var productos = ['Estados Unidos', 'Japon', 'Canada', 'Mexico', 'Rusia', 'Hong Kong', 'Malasia', 'Marruecos', 'Tailandia', 'Singapur', 'China', 'Norteamerica', 'Asia Multipaís', 'Vietnam', 'Suiza', 'Australia', 'Brasil', 'Chile', 'Colombia', 'Costa Rica', 'El Salvador', 'Israel', 'Nicaragua', 'Panama', 'Peru', 'Puerto Rico', 'Sri Lanka', 'Uruguay', 'America Latina Multipaís', 'Argentina', 'Kuwait', 'Nepal', 'India', 'Turquia', 'Brunei', 'Oman', 'Pakistan', 'Qatar', 'Serbia', 'Sudafrica', 'Egipto', 'Nueva York', 'New York', 'Paquistan', 'Corea del Sur', 'Camboya', 'Taiwan', 'Indonesia', 'Filipinas', 'Macao', 'Laos', 'Bali', 'USA', 'California', 'Miami', 'EEUU', 'Los Angeles', 'Andorra', 'Jordania', 'Tanzania', 'Tunez' ];
	
    /*
     * Petición para obtener podructos de la API REST
     */
    /*ajax_get('./admin/products.json', function(data) {
        //console.log(data.products);
        for (var i=0; i < data.products.length; i++) {
            var producto = data.products[i].title;
            productos.push(producto);
        }
        //console.log(productos);
    });*/

    autocomplete(document.getElementById("myInput"), productos);
});